/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ minutes: NonNullable<unknown> }} Quick_Workout_Notice_ShortInputs */

const en_us2_quick_workout_notice_short = /** @type {(inputs: Quick_Workout_Notice_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`About ${i?.minutes} min: for the rest of the time there was no possible, recovered exercise.`)
};

const pt_br2_quick_workout_notice_short = /** @type {(inputs: Quick_Workout_Notice_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Deu cerca de ${i?.minutes} min: para o resto do tempo não havia exercício possível e recuperado.`)
};

const es_419_quick_workout_notice_short = /** @type {(inputs: Quick_Workout_Notice_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Quedó en unos ${i?.minutes} min: para el resto del tiempo no había ningún ejercicio posible y recuperado.`)
};

const pt_pt2_quick_workout_notice_short = /** @type {(inputs: Quick_Workout_Notice_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Deu cerca de ${i?.minutes} min: para o resto do tempo não havia nenhum exercício possível e recuperado.`)
};

const fr_fr2_quick_workout_notice_short = /** @type {(inputs: Quick_Workout_Notice_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Environ ${i?.minutes} min : pour le reste du temps, aucun exercice possible et récupéré.`)
};

const de_de2_quick_workout_notice_short = /** @type {(inputs: Quick_Workout_Notice_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Etwa ${i?.minutes} min: Für die restliche Zeit gab es keine mögliche, erholte Übung.`)
};

const it_it2_quick_workout_notice_short = /** @type {(inputs: Quick_Workout_Notice_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Circa ${i?.minutes} min: per il resto del tempo non c'era nessun esercizio possibile e recuperato.`)
};

/**
* | output |
* | --- |
* | "About {minutes} min: for the rest of the time there was no possible, recovered exercise." |
*
* @param {Quick_Workout_Notice_ShortInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const quick_workout_notice_short = /** @type {((inputs: Quick_Workout_Notice_ShortInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quick_Workout_Notice_ShortInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_quick_workout_notice_short(inputs)
	if (locale === "es-419") return es_419_quick_workout_notice_short(inputs)
	if (locale === "pt-PT") return pt_pt2_quick_workout_notice_short(inputs)
	if (locale === "fr-FR") return fr_fr2_quick_workout_notice_short(inputs)
	if (locale === "de-DE") return de_de2_quick_workout_notice_short(inputs)
	if (locale === "it-IT") return it_it2_quick_workout_notice_short(inputs)
	return en_us2_quick_workout_notice_short(inputs)
});
export { quick_workout_notice_short as "quick-workout.notice_short" }